import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { QueryParameter } from "../helpers/queryParameter";
import { QueryFilter } from "../helpers/queryFilter";
import { UserContextService } from "./user-context.service";

const BASE_API = environment.apiUrl;
@Injectable({
  providedIn: "root",
})
export class ApiService {
  appSettings: any;
  constructor(private http: HttpClient) {}

  generateHttpRequest(
    query: QueryParameter,
    action: string,
    data,
    method: "GET" | "POST" | "PUT" | "PATCH",
    httpParams: any
  ): Observable<any> {
    let params: HttpParams = new HttpParams();
    if (query !== null) {
      params = params.append("query", JSON.stringify(query));
    }
    httpParams?.forEach((element) => {
      params = params.append(element.key, element.value);
    });
    if (method === "POST") {
      return this.http.post(BASE_API + "/" + action + "/", data, {
        params,
      });
    } else if (method === "PUT") {
      return this.http.put(BASE_API + "/" + action + "/", data, {
        params,
      });
    } else if (method === "PATCH") {
      return this.http.patch(BASE_API + "/" + action + "/", data, {
        params,
      });
    } else if (method === "GET") {
      return this.http.get(BASE_API + "/" + action, {
        params,
      });
    }
  }
  initSettings() {
    const url = BASE_API + "/config/init";
    return this.http.get(url);
    // this.appSettings = infos;
  }
  /** retourne un Observable du modèle pour la side bar de filtrage des données */
  getGanttModel() {
    return this.generateHttpRequest(null, "config/Gantt", null, "GET", null);
  }
  /** retourne un Observable du modèle */
  getModel(name) {
    return this.generateHttpRequest(null, `config/${name}`, null, "GET", null);
  }
  findModelList(model, query: QueryParameter) {
    return this.http.get(BASE_API + model.path, {
      params: new HttpParams().set("query", JSON.stringify(query)),
    });
  }
  /** retourne un Observable pret pour les combo box */
  getSelect(query, controller) {
    return this.generateHttpRequest(
      query,
      controller,
      null,
      "GET",
      null
    ).pipe();
  }
  /** retourne un queryParameter de base avec le site comme filtre */
  getQueryParamForSite(site): QueryParameter {
    const query = new QueryParameter();
    query.queryFilters = [];
    const filter: QueryFilter = {
      Name: "Site",
      QueryOperator: "Equal",
      Value: site,
    };
    query.queryFilters.push(filter);
    return query;
  }
  /** retourne un queryParameter avec le centre */
  getQueryParamForSiteAndCentre(site, centre): QueryParameter {
    const query = this.getQueryParamForSite(site);
    query.queryFilters = [];
    const filter: QueryFilter = {
      Name: "Centre",
      QueryOperator: "Equal",
      Value: centre,
    };
    query.queryFilters.push(filter);
    return query;
  }
}
